import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProductAnalysisFilters  {
    _originalTypeClassName = "zPMO.BO.ProductAnalysisFilters";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProductAnalysisFilters.translate = translateService;
}
this.DateFrom = null;
this.DateTo = null;
this.ProductAnalysisFiltersKey = null;
this._key = this.ProductAnalysisFiltersKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
FiscalYear:any;
Company:any;
Client:any;
private _ProductAnalysisFiltersKey:any;
get ProductAnalysisFiltersKey(): any {
    return this._ProductAnalysisFiltersKey;
  }
set ProductAnalysisFiltersKey(value: any) {
    this._ProductAnalysisFiltersKey = value;
    this._key = value;
  }
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setCompany = ($this, value) => {
var oldValue = $this.Company;
$this.Company = value;
if (value != null) {
}
}
static setClient = ($this, value) => {
var oldValue = $this.Client;
$this.Client = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ProductAnalysisFiltersKey == null || $this.ProductAnalysisFiltersKey == 0;
            }


}